/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react/macro"
import React from "react"
import { testValidEmail } from "../../helpers/ValidateEmail"
import history from "../../components/History"

const componentStyle = css`
    button.search,
    button.add {
        margin-top: 24px !important;
    }
`
class AddContact extends React.Component{

    state = {
        brokerCompanyId: "",
        admittedProducerCode: "",
        nyftzProducerCode: "",
        id: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        error: "",
        validating: false
    }
    
    componentDidMount(){
        window.scrollTo(0,0)

        const { brokerCompaniesContainer, accountsContainer } = this.props

        if(!brokerCompaniesContainer.state.brokerCompanies.length){
            history.push("/agencies-and-contacts")
        }

        if(accountsContainer.state.editAccount){            
            const account = accountsContainer.state.editAccount

            this.setState({
                brokerCompanyId: account.brokerCompanyId,
                admittedProducerCode: account.admittedProducerCode,
                nyftzProducerCode: account.nyftzProducerCode,
                id: account.id,
                firstName: account.firstName,
                lastName: account.lastName,
                phoneNumber: account.phoneNumber,
                email: account.email
            })
        }        
    }

    componentWillUnmount() {
        const { accountsContainer } = this.props
        accountsContainer.setState({
            editAccount: null
        })
      }

    updateValue = (e)=>{
        e = e.currentTarget

        let value = e.value

        this.setState({
            [e.name]: value
        })

        if(this.state.validating){
            this.validateForm()
        }
    }

    addAccount = async ()=>{
        if(!await this.validateForm()){
            return
        }

        const { brokerCompaniesContainer, accountsContainer } = this.props

        let result
        if(accountsContainer.state.editAccount){
            result = await accountsContainer.updateAccount(this.state)
        }else{
            result = await accountsContainer.addAccount(this.state)
        }

        if(!result?.succeeded){
            return
        }else{
            await brokerCompaniesContainer.getBrokerCompany(this.state.brokerCompanyId, true)
            history.push("/agencies-and-contacts")
        }
    }

    validateForm = async ()=>{
        this.setState({
            validating: true
        })

        const notRequired = [
            "admittedProducerCode",
            "brokerCompany",
            "id",
            "error",
            "validating",
            "nyftzProducerCode"
        ]

        let valid = true
        let error = "Please complete all required fields"

        for (const [key, value] of Object.entries(this.state)) {
            if(!notRequired.includes(key)){
                if(!value){
                    valid = false
                    break
                }
            }
        }

        if(valid){
            if(!testValidEmail(this.state.email)){
                valid = false
                error = "Please enter a valid email address"
            }
        }

        if(!valid){
            this.setState({
                error: error
            })
            return false
        }else{
            this.setState({
                error: ""
            })
            return true
        }      
    }

    cancel = async ()=>{
        history.push("/agencies-and-contacts")
    }

    render(){
        const { brokerCompaniesContainer, accountsContainer } = this.props

        return(
            <>
            <div css={componentStyle}>
                <div className="row margin-top">
                    <div className="col">
                        <h2>{accountsContainer.state.editAccount ? "Edit" : "Add"} Contact</h2>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-6">
                <div className="form-group">
                        <label htmlFor="brokerCompanyId"
                                className={(this.state.validating && !this.state.brokerCompanyId) 
                                ? "required" : ""}>
                            Agency:<span className="required">*</span>
                        </label>
                        <select className="form-control form-control-sm" 
                                id="brokerCompanyId"
                                name="brokerCompanyId"
                                value={this.state.brokerCompanyId}
                                onChange={this.updateValue}>                            
                            <option value="">--- Select ---</option>
                            {brokerCompaniesContainer.state.brokerCompanies.map(brokerCompany =>(
                                <option key={brokerCompany.id}
                                        value={brokerCompany.id}>
                                    {brokerCompany.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="firstName"
                            className={(this.state.validating && !this.state.firstName) 
                                ? "required" : ""}>First Name:<span className="required">*</span>
                        </label>
                        <input type="text" 
                                className="form-control form-control-sm" 
                                id="firstName" 
                                name="firstName"
                                value={this.state.firstName}
                                onChange={this.updateValue} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="lastName"
                            className={(this.state.validating && !this.state.lastName) 
                            ? "required" : ""}>
                            Last Name:<span className="required">*</span>
                        </label>
                        <input type="text" 
                                className="form-control form-control-sm" 
                                id="lastName" 
                                name="lastName"
                                value={this.state.lastName}
                                onChange={this.updateValue} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="phoneNumber"
                            className={(this.state.validating && !this.state.phoneNumber) 
                                ? "required" : ""}>
                            Mobile Phone Number:<span className="required">*</span>
                        </label>
                        <input type="text" 
                                className="form-control form-control-sm" 
                                id="phoneNumber" 
                                name="phoneNumber"
                                value={this.state.phoneNumber}
                                onChange={this.updateValue} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email"
                            className={(this.state.validating && (!this.state.email || !testValidEmail(this.state.email))) 
                                ? "required" : ""}>
                                Email Address (Username):<span className="required">*</span>
                        </label>
                        <input type="email" 
                                className="form-control form-control-sm" 
                                id="email" 
                                name="email"
                                value={this.state.email}
                                onChange={this.updateValue}
                                required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="admittedProducerCode"
                            className={(this.state.validating && 
                                        !this.state.admittedProducerCode &&
                                        this.state.producerCode === "yes") 
                            ? "required" : ""}>
                            GAIG Admitted Producer Code:
                            {this.state.producerCode === "yes" &&
                                <span className="required">*</span>
                            }
                        </label>
                        <input type="text" 
                                className="form-control form-control-sm" 
                                id="admittedProducerCode" 
                                name="admittedProducerCode"
                                value={this.state.admittedProducerCode}
                                onChange={this.updateValue} />
                    </div>                       
                    <div className="form-group">
                        <label htmlFor="nyftzProducerCode">
                            NYFTZ Producer Code:
                        </label>
                        <input type="text" 
                                className="form-control form-control-sm" 
                                id="nyftzProducerCode" 
                                name="nyftzProducerCode"
                                value={this.state.nyftzProducerCode}
                                onChange={this.updateValue} />
                    </div>                       
                </div>
            </div>

            {this.state.error !== "" &&
                <div className="row">
                    <div className="col-sm-6">
                        <p className="error">{this.state.error}</p>
                    </div>
                </div>
            }
    
            <div className="row button-group">
                <div className="col-sm-6">
                    <button className="btn btn-sm btn-primary float-right"
                            onClick={this.addAccount}
                            disabled={brokerCompaniesContainer.state.isLoading}>Submit</button>
                    <button className="btn btn-sm btn-secondary float-right"
                            onClick={this.cancel}
                            disabled={brokerCompaniesContainer.state.isLoading}>Cancel</button>
                    
                </div>
            </div>
            </>
        )
    }   
}

export default AddContact